import React, { useState, useEffect } from 'react';
import { ordersAPI } from '../services/api';

export default function OrdersManagement() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    loadOrders();
  }, [filter, page]);

  const loadOrders = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 20 };
      if (filter !== 'all') params.status = filter;
      const { data } = await ordersAPI.getAll(params);
      setOrders(data.orders);
      setTotal(data.total);
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const statuses = [
    { key: 'all', label: 'الكل' },
    { key: 'pending', label: 'معلق' },
    { key: 'accepted', label: 'مقبول' },
    { key: 'in_progress', label: 'جاري' },
    { key: 'completed', label: 'مكتمل' },
    { key: 'cancelled', label: 'ملغي' },
  ];

  return (
    <div>
      <div className="page-header">
        <h2>إدارة الطلبات</h2>
        <div className="filters">
          {statuses.map((s) => (
            <button
              key={s.key}
              className={`filter-btn ${filter === s.key ? 'active' : ''}`}
              onClick={() => { setFilter(s.key); setPage(1); }}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="loading">جاري التحميل...</div>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>رقم الطلب</th>
                <th>العميل</th>
                <th>العامل</th>
                <th>الحالة</th>
                <th>المبلغ</th>
                <th>العمولة</th>
                <th>الدفع</th>
                <th>التاريخ</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td><strong>{order.orderNumber}</strong></td>
                  <td>{order.customer?.name}</td>
                  <td>{order.worker?.name || '-'}</td>
                  <td>
                    <span className={`badge ${order.status}`}>
                      {getStatusLabel(order.status)}
                    </span>
                  </td>
                  <td>{order.totalPrice} ج.م</td>
                  <td>{order.commission?.toFixed(0)} ج.م</td>
                  <td>{order.paymentMethod === 'cash' ? 'كاش' : 'إلكتروني'}</td>
                  <td>{new Date(order.createdAt).toLocaleDateString('ar-SA')}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button disabled={page <= 1} onClick={() => setPage(page - 1)}>السابق</button>
            <span>صفحة {page} من {Math.ceil(total / 20)}</span>
            <button disabled={page >= Math.ceil(total / 20)} onClick={() => setPage(page + 1)}>التالي</button>
          </div>
        </>
      )}
    </div>
  );
}

function getStatusLabel(status) {
  const map = {
    pending: 'معلق', accepted: 'مقبول', on_the_way: 'في الطريق',
    arrived: 'وصل', in_progress: 'جاري التنفيذ',
    completed: 'مكتمل', cancelled: 'ملغي',
  };
  return map[status] || status;
}
